const e = (r) => r ? { Authorization: `Bearer ${r}` } : {};
export {
  e as createBearerAuthHeader
};
//# sourceMappingURL=auth-header.js.map
